import { useCallback, useRef } from 'react'
import L from 'leaflet'
import type { MapSnapshot } from '../types'

interface UseMapSnapshotProps {
  mapRef: React.MutableRefObject<L.Map | null>
  isInitializedRef: React.MutableRefObject<boolean>
}

export const useMapSnapshot = ({ mapRef, isInitializedRef }: UseMapSnapshotProps) => {
  const mapSnapshotRef = useRef<MapSnapshot | null>(null)
  const isSnapshotLockedRef = useRef(false)

  const saveMapSnapshot = useCallback(() => {
    if (!mapRef.current || !isInitializedRef.current) return

    try {
      const center = mapRef.current.getCenter()
      const zoom = mapRef.current.getZoom()
      const bounds = mapRef.current.getBounds()

      mapSnapshotRef.current = {
        center: [center.lat, center.lng],
        zoom,
        bounds: bounds ? L.latLngBounds(bounds.getSouthWest(), bounds.getNorthEast()) : null
      }

      try {
        sessionStorage.setItem('mapSnapshot', JSON.stringify({
          center: mapSnapshotRef.current.center,
          zoom: mapSnapshotRef.current.zoom,
          timestamp: Date.now()
        }))
      } catch (e) {
        // Ignore storage errors
      }

      isSnapshotLockedRef.current = true
    } catch (error) {
      console.warn('Error saving map snapshot:', error)
    }
  }, [mapRef, isInitializedRef])

  const unlockSnapshot = useCallback(() => {
    isSnapshotLockedRef.current = false
  }, [])

  return {
    mapSnapshotRef,
    isSnapshotLockedRef,
    saveMapSnapshot,
    unlockSnapshot,
  }
}
